import { useEffect, useRef, useState } from 'react'

/**
 * Blur-bridge label: when the text changes (e.g. Confirm → Applying…), it crossfades
 * through a subtle blur instead of a hard swap — Emil Kowalski's technique for making a
 * state change read as one smooth morph rather than two objects overlapping. CSS-only;
 * neutralised under reduced-motion.
 */
export function MorphLabel({ children }: { children: string }) {
  const [shown, setShown] = useState(children)
  const [morphing, setMorphing] = useState(false)
  const prev = useRef(children)

  useEffect(() => {
    if (children === prev.current) return
    prev.current = children
    setMorphing(true)
    const t = setTimeout(() => {
      setShown(children)
      setMorphing(false)
    }, 110)
    return () => clearTimeout(t)
  }, [children])

  return (
    <span
      className="inline-block transition-[filter,opacity] duration-150 ease-out motion-reduce:transition-none"
      style={morphing ? { filter: 'blur(2px)', opacity: 0.55 } : undefined}
    >
      {shown}
    </span>
  )
}
